(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-page-header"] && !Shopify.designMode) return;
  try {
    
  class CollectionFilterBar extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-cph-control]').forEach((sel) => {
        sel.addEventListener('change', () => {
          const param = sel.dataset.param;
          const url = new URL(window.location.href);
          if (sel.value) {
            url.searchParams.set(param, sel.value);
          } else {
            url.searchParams.delete(param);
          }
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });
    }
  }
  customElements.define('collection-filter-bar', CollectionFilterBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-hero"] && !Shopify.designMode) return;
  try {
    
  class MvHeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-mv-track]');
      this.slides = Array.from(this.querySelectorAll('[data-mv-slide]'));
      // Dots live in the red bar, which is a sibling of this element — query the whole section.
      const root = this.closest('.mv-hero') || this.parentNode || document;
      this.dots = Array.from(root.querySelectorAll('[data-mv-dot]'));
      this.realCount = this.slides.length;

      if (this.realCount <= 1) return;

      // Clone first & last slides for an infinite center-peek loop
      const firstClone = this.slides[0].cloneNode(true);
      const lastClone = this.slides[this.realCount - 1].cloneNode(true);
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      firstClone.dataset.clone = 'true';
      lastClone.dataset.clone = 'true';
      this.track.appendChild(firstClone);
      this.track.insertBefore(lastClone, this.slides[0]);

      this.allSlides = Array.from(this.track.children);
      this.current = 1; // first real slide (after the prepended clone)

      this.center(false);

      this.querySelector('[data-mv-prev]')?.addEventListener('click', () => this.go(-1));
      this.querySelector('[data-mv-next]')?.addEventListener('click', () => this.go(1));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.mvDot, 10) + 1));
      });

      this.track.addEventListener('transitionend', () => this.onTransitionEnd());

      this._resize = this.debounce(() => this.center(false), 150);
      window.addEventListener('resize', this._resize);

      // Touch / swipe support
      this.bindSwipe();

      // Autoplay
      if (this.dataset.autoplay === 'true') {
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.start();
      }
    }

    disconnectedCallback() {
      this.stop();
      window.removeEventListener('resize', this._resize);
    }

    center(animate) {
      const slide = this.allSlides[this.current];
      const offset = this.clientWidth / 2 - (slide.offsetLeft + slide.offsetWidth / 2);
      this._offset = offset;
      this.track.classList.toggle('is-no-transition', !animate);
      this.track.style.transform = `translateX(${offset}px)`;
      this.updateDots();
      if (!animate) {
        // Force reflow so the next animated move transitions correctly
        void this.track.offsetWidth;
        this.track.classList.remove('is-no-transition');
      }
    }

    go(dir) {
      this.current += dir;
      this.center(true);
    }

    goTo(index) {
      this.current = index;
      this.center(true);
    }

    onTransitionEnd() {
      const slide = this.allSlides[this.current];
      if (slide && slide.dataset.clone === 'true') {
        // Jump from a clone back to the matching real slide without animation
        this.current = this.current === 0 ? this.realCount : 1;
        this.center(false);
      }
    }

    updateDots() {
      const real = ((this.current - 1) % this.realCount + this.realCount) % this.realCount;
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === real));
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.go(1), this.speed);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
    }

    bindSwipe() {
      // Pointer events: works for both mouse (PC) and touch (SP), with live drag.
      this.dragging = false;
      this.dragLock = null;   // null | 'x' | 'y'
      this.dragMoved = false;

      this.addEventListener('pointerdown', (e) => {
        if (e.target.closest('button')) return;            // ignore arrows/dots
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        this.dragging = true;
        this.dragLock = null;
        this.dragMoved = false;
        this.startX = e.clientX;
        this.startY = e.clientY;
        this.base = this._offset || 0;
        this.track.classList.add('is-no-transition');
        this.classList.add('is-dragging');
        this.stop();
      });

      this.addEventListener('pointermove', (e) => {
        if (!this.dragging) return;
        const dx = e.clientX - this.startX;
        const dy = e.clientY - this.startY;
        if (this.dragLock === null) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          this.dragLock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (this.dragLock === 'y') { this.endDrag(0); return; } // let the page scroll
          try { this.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (this.dragLock !== 'x') return;
        if (Math.abs(dx) > 5) this.dragMoved = true;
        this.track.style.transform = `translateX(${this.base + dx}px)`;
      });

      const release = (e) => {
        if (!this.dragging) return;
        this.endDrag(e.clientX - this.startX);
      };
      this.addEventListener('pointerup', release);
      this.addEventListener('pointercancel', () => this.endDrag(0));

      // Prevent a drag from triggering the slide link click.
      this.addEventListener('click', (e) => {
        if (this.dragMoved) {
          e.preventDefault();
          e.stopPropagation();
          this.dragMoved = false;
        }
      }, true);
    }

    endDrag(dx) {
      if (!this.dragging) return;
      this.dragging = false;
      this.classList.remove('is-dragging');
      this.track.classList.remove('is-no-transition');
      const threshold = Math.min(80, this.clientWidth * 0.12);
      if (Math.abs(dx) > threshold) {
        this.go(dx < 0 ? 1 : -1);
      } else {
        this.center(true);
      }
      if (this.dataset.autoplay === 'true') this.start();
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  customElements.define('mv-hero-slider', MvHeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pickup-items"] && !Shopify.designMode) return;
  try {
    
  class PickupCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-pickup-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-pickup-prev]');
      this.next = this.querySelector('[data-pickup-next]');

      this.prev && this.prev.addEventListener('click', () => this.scrollByCard(-1));
      this.next && this.next.addEventListener('click', () => this.scrollByCard(1));
    }

    step() {
      const card = this.track.querySelector('[data-pickup-card]');
      if (!card) return this.track.clientWidth;
      const gap = parseInt(getComputedStyle(this.track).columnGap || '24', 10) || 24;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByCard(dir) {
      this.track.scrollBy({ left: this.step() * dir, behavior: 'smooth' });
    }
  }

  customElements.define('pickup-carousel', PickupCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["your-checked"] && !Shopify.designMode) return;
  try {
    
  class YourChecked extends HTMLElement {
    connectedCallback() {
      this.KEY = 'ravie:recentlyViewed';
      this.max = parseInt(this.dataset.max, 10) || 8;

      let list = [];
      try { list = JSON.parse(localStorage.getItem(this.KEY)) || []; } catch (e) { list = []; }

      let current = null;
      if (this.dataset.current) {
        try { current = JSON.parse(this.dataset.current); } catch (e) { current = null; }
      }

      if (current && current.url) {
        list = list.filter((item) => item.url !== current.url);
        list.unshift(current);
        list = list.slice(0, 12);
        try { localStorage.setItem(this.KEY, JSON.stringify(list)); } catch (e) {}
      }

      const items = (current ? list.filter((item) => item.url !== current.url) : list).slice(0, this.max);
      if (!items.length) { this.remove(); return; }

      const grid = this.querySelector('[data-ychk-grid]');
      items.forEach((item) => grid.appendChild(this.buildCard(item)));
      this.hidden = false;

      this.grid = grid;
      this.setupSlider();
    }

    setupSlider() {
      const grid = this.grid;
      const nav = this.querySelector('[data-ychk-nav]');
      const prev = this.querySelector('[data-ychk-prev]');
      const next = this.querySelector('[data-ychk-next]');

      const step = () => {
        const card = grid.querySelector('.ychk-card');
        if (!card) return grid.clientWidth * 0.8;
        const gap = parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const update = () => {
        const scrollable = grid.scrollWidth - grid.clientWidth > 1;
        if (nav) nav.hidden = !scrollable;
        if (prev) prev.disabled = grid.scrollLeft <= 1;
        if (next) next.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 1;
      };

      if (prev) prev.addEventListener('click', () => { grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', () => { grid.scrollBy({ left: step(), behavior: 'smooth' }); });

      grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(grid);
      update();

      // Drag-to-scroll (pointer-based: works on PC and touch).
      let down = false, moved = false, startX = 0, startScroll = 0;
      grid.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        down = true; moved = false;
        startX = e.clientX;
        startScroll = grid.scrollLeft;
      });
      grid.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) {
          moved = true;
          grid.classList.add('is-dragging');
          try { grid.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (moved) grid.scrollLeft = startScroll - dx;
      });
      const endDrag = () => {
        if (!down) return;
        down = false;
        grid.classList.remove('is-dragging');
        update();
      };
      grid.addEventListener('pointerup', endDrag);
      grid.addEventListener('pointercancel', endDrag);
      grid.addEventListener('pointerleave', endDrag);
      // Suppress the click that follows a drag.
      grid.addEventListener('click', (e) => {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    }

    buildCard(item) {
      const a = document.createElement('a');
      a.className = 'ychk-card';
      a.href = item.url;

      const media = document.createElement('div');
      media.className = 'ychk-card__media';
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        media.appendChild(img);
      }
      a.appendChild(media);

      const title = document.createElement('p');
      title.className = 'ychk-card__title';
      title.textContent = item.title || '';
      a.appendChild(title);

      const price = document.createElement('p');
      price.className = 'ychk-card__price';
      if (item.compare) {
        const was = document.createElement('s');
        was.className = 'rprice__was';
        was.textContent = item.compare;
        const now = document.createElement('span');
        now.className = 'rprice__now rprice__now--sale';
        now.textContent = item.price || '';
        price.appendChild(was);
        price.appendChild(document.createTextNode(' '));
        price.appendChild(now);
      } else {
        price.textContent = item.price || '';
      }
      a.appendChild(price);

      return a;
    }
  }

  customElements.define('your-checked', YourChecked);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube"] && !Shopify.designMode) return;
  try {
    
  class YoutubeFacade extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.play.bind(this));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.play();
        }
      });
    }

    play() {
      if (this.classList.contains('is-playing')) return;
      const id = this.dataset.id;
      if (!id) return;
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', 'YouTube video player');
      this.classList.add('is-playing');
      this.appendChild(iframe);
    }
  }

  customElements.define('youtube-facade', YoutubeFacade);

  } catch(e) { console.error(e); }
})();
})();
